import React, { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { PageHeader, adminBtnPrimary, adminField } from "@/components/admin/ui";

export default function AdminCategories() {
  const [items, setItems] = useState([]);
  const [name, setName] = useState("");

  const load = () => api.get("/admin/categories").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    if (!name.trim()) return;
    try {
      await api.post("/admin/categories", { name });
      setName("");
      toast.success("Category added");
      load();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this category?")) return;
    await api.delete(`/admin/categories/${id}`);
    toast.success("Category deleted");
    load();
  };

  return (
    <>
      <PageHeader title="Categories" subtitle="Organize articles by topic. Categories appear as filters on the site." />
      <div className="max-w-xl">
        <form onSubmit={add} className="flex gap-3">
          <input value={name} onChange={(e) => setName(e.target.value)} placeholder="New category name" className={adminField} data-testid="category-input" />
          <button type="submit" className={adminBtnPrimary} data-testid="add-category-button"><Plus className="h-4 w-4" /> Add</button>
        </form>
        <div className="mt-6 divide-y divide-cream-200 border border-ink/10 bg-cream-100">
          {items.map((c) => (
            <div key={c.id} className="flex items-center justify-between px-5 py-4" data-testid={`category-row-${c.slug}`}>
              <span className="font-sans text-sm text-ink">{c.name}</span>
              <button onClick={() => remove(c.id)} className="text-steel-400 hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
            </div>
          ))}
          {items.length === 0 && <p className="py-10 text-center font-sans text-sm text-steel-400">No categories yet.</p>}
        </div>
      </div>
    </>
  );
}
